const SWIPE_DISTANCE_PX = 48;
const SWIPE_FLICK_VELOCITY_X = 700;

/**
 * Map a horizontal pan to a period-window delta.
 * Swipe left (calendar page forward) → next window; swipe right → previous.
 */
export function windowShiftDeltaFromPan(
    translationX: number,
    velocityX: number,
): number {
    "worklet";

    if (
        translationX <= -SWIPE_DISTANCE_PX ||
        velocityX <= -SWIPE_FLICK_VELOCITY_X
    ) {
        return 1;
    }

    if (
        translationX >= SWIPE_DISTANCE_PX ||
        velocityX >= SWIPE_FLICK_VELOCITY_X
    ) {
        return -1;
    }

    return 0;
}
